module.exports = __webpack_public_path__ + "img/calendar-date-fill.a6d16195.svg";